import Table from '@app/src/components/Table'
import { useClientSidePagination } from '@app/src/hooks/clientSidePagination'
import usePaginationWithQuery from '@app/src/hooks/paginationWithQuery'
import type { OrganizationRiskSetting } from '@app/src/types/resourceExplorer'
import React from 'react'
import RiskSettingsHeader from './RiskSettingsHeader'
import RiskSettingsRow from './RiskSettingsRow'

interface RiskSettingsRowProps {
  isEditMode: boolean
  onToggleChange: (riskIndexId: number, isActivated: boolean) => void
  modifiedRiskStates: Map<number, boolean>
}

interface RiskSettingsTableProps extends RiskSettingsRowProps {
  settings: OrganizationRiskSetting[]
  isLoading: boolean
  isError: boolean
  /** Values that send the reader back to page 1 when they change, e.g. the active filters. */
  filterDependencies?: unknown[]
}

const RiskSettingsTable: React.FC<RiskSettingsTableProps> = ({
  settings,
  isEditMode,
  isLoading,
  isError,
  onToggleChange,
  modifiedRiskStates,
  filterDependencies,
}) => {
  const [page, pageSize, setPage, setPageSize] = usePaginationWithQuery(undefined, filterDependencies)
  const { paginatedData, count } = useClientSidePagination(settings, page, pageSize)

  // Table only accepts extra row props as an untyped bag, so keep the shape checked here.
  const rowProps: RiskSettingsRowProps = { isEditMode, onToggleChange, modifiedRiskStates }

  return (
    <Table<OrganizationRiskSetting>
      HeaderComponent={RiskSettingsHeader}
      RowComponent={RiskSettingsRow}
      rowComponentProps={rowProps}
      count={count}
      data={paginatedData}
      isLoading={isLoading}
      isError={isError}
      page={page}
      pageSize={pageSize}
      setPage={setPage}
      setPageSize={setPageSize}
    />
  )
}

export default RiskSettingsTable
